import Expandable from '../classes/ExpandableClass';

const selectors = {
    el: '.js-expandable:not(.is-initialized)',
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        el.expandable = new Expandable(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;
